export enum EGaTypes {
	DASHBOARD = 'dashboard',
	HEADER = 'header',
	HEADER_FILTER = 'header;filter',
	FILTER = 'filter',
	FOOTER = 'footer',
	BRANDS_CATALOG = 'brands catalog',
	JOIN_POPUP = 'join popup',
	MY_SOURCES = 'my sources',
	CREATING_SOURCES = 'creating a source',
	SAVING_SOURCES = 'saving a source',
	SIDE_MENU = 'side menu',
	TABS = 'tabs',
	WELCOME_POPUP = 'welcome popup',
	POPUP_STEP_ONE = 'popup;step 1',
	POPUP_STEP_TWO = 'popup;step 2',
	POPUP_STEP_THREE = 'popup;step 3',
	CONGRATULATION_POPUP = 'congratulation popup',
}
